'use client'
import { useState, type FC } from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'motion/react'
import { useDeviceType, useInView, useTranslator } from '@/hooks'
import { mq, vw, designGrid, getP75, getTransition } from '@/styles'
import { RandomWord } from './RandomWord'
import { VideoLocal } from '../VideoLocal'

// PENDING NEW SIZE OF HEADER VIDEO

export const HeaderHome:FC = () => {
  const { t } = useTranslator()
  const [videoReady, setVideoReady] = useState(false)
  const { mobileDevice, isMobile } = useDeviceType()

  const { ref } = useInView({ rootMargin: '0px 0px -100px 0px' })

  return (
    <Header ref={ref} $videoReady={videoReady} className='h--home'>
      <div className='react-player'>
        <VideoLocal key={`video-${(mobileDevice || isMobile) ? 'mobile' : 'desktop'}`} data={{ src: `/videos/DY_Home_animation${(mobileDevice ||isMobile) ? '_mobile' : ''}.mp4`, contentType: 'video/mp4', alt: 'DY Homepage intro video' }} setVideoReady={setVideoReady} play={true} options={{ autoPlay: true, muted: true, loop: true }}/>
      </div>
      <AnimatePresence>
        <motion.div className='text-wrapper' variants={variants} initial='initial' animate={videoReady ? 'animate' : 'initial'} exit='exit'>
          <h1>
            {t('home.header.title')}
            <RandomWord words={t('home.header.title_words')} />
          </h1>
        </motion.div>
      </AnimatePresence>
    </Header>
  )
}

const Header = styled.header<{ $videoReady: boolean }>`
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: ${vw(60, 'mobile')};
  min-height: 60vh;
  mix-blend-mode: multiply;
  transform: translateZ(0) translate3d(0,0,0);
  transition: 100ms filter linear;
  position: relative;

  ${mq.greaterThan('tablet')} {
    margin-top: ${vw(100, 'desktop')};
    min-height: 70vh;
  }

	.text-wrapper {
    ${designGrid({})}
    align-self: flex-start;
    padding-top: ${vw(22, 'mobile')};
    position: absolute;
    z-index: 2;

    ${mq.greaterThan('tablet')} {
      padding-top: ${vw(76, 'desktop')};
      z-index: 5;
    }
	}

  .react-player {
    flex-grow: 2;
    height: 100%;
    padding-top: 200px;
    width: 100%;

    ${mq.greaterThan('tablet')} {
      padding-top: 15px;
      padding-left: 3vw
    }

    video {
      height: auto;
      min-height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }

  h1 {
    ${getP75()}
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    grid-column: 1 / span 6;
    justify-content: flex-start;
    /* position: absolute; */
    text-align: left;

    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 6;
      grid-row: 1 / span 1;
    }
  }

  img {
    height: 100%;
    margin: 0;
    object-fit: cover;
    width: 100%;
  }

  /* video {
    outline: 0 !important;
    opacity: ${({ $videoReady }) => $videoReady ? 1 : 0};
    pointer-events: none;
    transition: 100ms opacity linear;
    user-select: none;
  } */
`

const variants = {
  initial: {
    y: '-100%',
    opacity: 0,
    transition: {
      ...getTransition(),
    }
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ...getTransition(),
      ease: [0.6, 0.2, 0.4, 1.5],
      delay: 2
    }
  }
} as const
